import React, { FunctionComponent } from "react";
import "./index.scss";

interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

type ImageGridProps = {
  code?: string | any;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
  backgroundAssetSize?: string;
  sectionPadding?: string | any;
  images?: URL[] | null;
};

export const ImageGrid: FunctionComponent<ImageGridProps> = ({
  code,
  backgroundAsset,
  backgroundAssetPosition = {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
  backgroundAssetSize,
  sectionPadding,
  images,
}) => {
  return (
    <section className={`section--image-grid`}>
      <div
        className="background-image"
        style={{
          top: backgroundAssetPosition.top,
          right: backgroundAssetPosition.right,
          bottom: backgroundAssetPosition.bottom,
          left: backgroundAssetPosition.left,
        }}
      >
        {backgroundAsset && backgroundAsset.length && (
          <img src={backgroundAsset} alt="box illustration" />
        )}
      </div>

      <div className="image-grid">
        {images &&
          images.length > 0 &&
          images.map((image: URL, i: number) => {
            return (
              <div key={`image-${i}`} className="image-wrapper">
                <img
                  src={(image as URL) && image.href.toString()}
                  alt="banner of Sook"
                />
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default ImageGrid;
